import React, { useContext, useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CategoryGrid from "./components/CategoryGrid";
import axios from "axios";
import { AuthContext, base_url } from "../context/Authcontext";
import "../../src/assets/AdminCss/card.css";
import toast from "react-hot-toast";
import Racing from "./components/Racing";
import MarqueeBottom from "./components/MarqueeBottom";
import LoginModal from "./LoginModal";
import { useTheme } from "../context/ThemeContext";
import { GiTennisBall } from "react-icons/gi";
import { FaBaseballBatBall } from "react-icons/fa6";

const formatDate = (dateString) => {
  if (!dateString) return null;

  const dateObj = new Date(dateString);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`; // Only date (YYYY-MM-DD)
};

const compareWithToday = (eventDate, allEvents) => {
  const now = new Date();
  const eventDateObj = new Date(eventDate);

  // Convert both to local date strings (YYYY-MM-DD) for comparison
  const todayDate = now.toISOString().split("T")[0];
  const eventDateFormatted = eventDateObj.toISOString().split("T")[0];

  // Get time in minutes since midnight
  const currentMinutes = getMinutesSinceMidnight(now);
  const eventMinutes = getMinutesSinceMidnight(eventDateObj);

  // Calculate 7 hours ago in minutes
  const sevenHoursAgo = currentMinutes - 420; // 7 * 60 minutes

  // Ensure the event is today
  if (todayDate !== eventDateFormatted) {
    return false;
  }

  // Return true if the event is within the range from 7 hours ago to the end of today
  return eventMinutes >= sevenHoursAgo;
};

const getMinutesSinceMidnight = (date) => {
  return date.getUTCHours() * 60 + date.getUTCMinutes();
};

const Inplay = ({
  data,
  scrollableList,
  isActive,
  disabledItems,
  handleClicktoast,
  handleActiveLink,
}) => {
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const [cricket, setCricket] = useState([]);
  const [football, setFootball] = useState([]);
  const [avail, setAvail] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBet, setSelectedBet] = useState(0);
  const [backActive, setbackActive] = useState(0);
  const [layActive, setlayActive] = useState(0);
  const [money, setMoney] = useState(0);
  const [pr, setPr] = useState(0);
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [side, setSide] = useState("");
  const [active, setActive] = useState(false);
  const [active1, setactive] = useState(false);
  const [selectedMatch, setSelectedMatch] = useState("");
  const [selectionid, setSelectionid] = useState();
  const [runner, setRunner] = useState();
  const [competition, setCompetition] = useState();
  const [eventid, setEventid] = useState();
  const [eventname, setEventname] = useState();
  const [profit, setProfit] = useState(0);
  const [time, setTime] = useState();
  const [lockedMatch, setLockedMatch] = useState([]);
  const [lockedMatchesLoaded, setLockedMatchesLoaded] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);
  const { themeColors } = useTheme();
  const [aviator, setAviator] = useState();

  // ✅ NEW STATES
  const [rawMatches, setRawMatches] = useState([]);
  const [marketList, setMarketList] = useState([]);

  const sortMatches = (matches) => {
    return [...matches].sort((a, b) => {

      const aLive = a?.inplay || a?.event?.inPlay || a?.event?.status === "LIVE";
      const bLive = b?.inplay || b?.event?.inPlay || b?.event?.status === "LIVE";

      // 1️⃣ Live matches first
      if (aLive && !bLive) return -1;
      if (!aLive && bLive) return 1;

      // 2️⃣ Then by increasing start time
      const timeA = new Date(a?.event?.openDate).getTime();
      const timeB = new Date(b?.event?.openDate).getTime();

      return timeA - timeB;
    });
  };

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 991);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const matchDatabaseData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        base_url + "/api/webapi/matchDatabaseData",
        { headers: { "Content-Type": "application/json" } }
      );
      setLockedMatch(response.data.data);
      setLockedMatchesLoaded(true);
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ STEP 1A: matchData - setRawMatches instead of setCricket
  const matchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + "/api/webapi/matchapi", {
        headers: { "Content-Type": "application/json" },
      });
      console.log("API Response:", response?.data);
      const data = response?.data?.result?.data || [];
      const allOpenDates = data.map(dta => dta?.event?.openDate);
      const allData = [];
      data.forEach((dta) => {
        if (compareWithToday(dta?.event?.openDate, allOpenDates)) {
          allData.push(dta);
        }
      });
      console.log("Filtered Matches for Today:", allData);
      setRawMatches(allData); // ✅ changed
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ STEP 1B: footballData - setRawMatches instead of setCricket
  const footballData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + "/api/webapi/footballapi", {
        headers: { "Content-Type": "application/json" },
      });
      console.log("Football API Response:", response?.data);
      const data = response?.data?.result?.data || [];
      const allOpenDates = data.map(dta => dta?.event?.openDate);
      const allData = [];
      data.forEach((dta) => {
        if (compareWithToday(dta?.event?.openDate, allOpenDates)) {
          allData.push(dta);
        }
      });
      console.log("Filtered Football Matches:", allData);
      setRawMatches(allData); // ✅ changed
    } catch (error) {
      console.error("Football API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ STEP 1C: tennisData - setRawMatches instead of setCricket
  const tennisData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + "/api/webapi/tennisapi", {
        headers: { "Content-Type": "application/json" },
      });
      console.log("Tennis API Response:", response?.data);
      const data = response?.data?.result?.data || [];
      const allOpenDates = data.map(dta => dta?.event?.openDate);
      const allData = [];
      data.forEach((dta) => {
        if (compareWithToday(dta?.event?.openDate, allOpenDates)) {
          allData.push(dta);
        }
      });
      console.log("Filtered Tennis Matches:", allData);
      setRawMatches(allData); // ✅ changed
    } catch (error) {
      console.error("Tennis API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ STEP 2: rawMatches changes → getMarkets (no more loop because we don't set rawMatches here)
  useEffect(() => {
    const getMarkets = async () => {

      if (rawMatches.length === 0) return;

      try {

        const eventIds = rawMatches.map(item => item?.event?.id);

        const response = await axios.post(
          `${base_url}/game/kheloyaar/getMarkets`,
          { eventIds }
        );

        const markets = response.data.data || [];

        // 🔥 SORT MATCHES
        const sortedMarkets = sortMatches(markets);

        setMarketList(sortedMarkets);
        setCricket(sortedMarkets);

      } catch (err) {
        console.error("Markets Error:", err);
      }

    };

    getMarkets();

  }, [rawMatches]);

  // ✅ STEP 3: marketList changes → fetchOdds (no more loop because we don't set marketList here)
  useEffect(() => {
    const fetchOdds = async () => {
      if (!marketList || marketList.length === 0) return;
      try {
        const marketIds = marketList.map(item => item.marketId).filter(Boolean);
        const chunks = [];
        for (let i = 0; i < marketIds.length; i += 10) {
          chunks.push(marketIds.slice(i, i + 10));
        }
        let allOdds = [];
        for (const chunk of chunks) {
          const response = await axios.post(
            `${base_url}/api/webapi/market/wholeMarket`,
            { marketIds: chunk }
          );
          const oddsData =
            typeof response.data === "string"
              ? JSON.parse(response.data)
              : response.data;
          const markets = oddsData?.data?.data || [];
          allOdds = [...allOdds, ...markets];
        }
        console.log("Fetched Odds Data:", allOdds);
        setAvail(allOdds);
      } catch (error) {
        console.error("Odds Fetch Error:", error);
      }
    };
    fetchOdds();
  }, [marketList]); // ✅ only marketList — no loop

  const [formData, setFormData] = useState({
    competiton: "",
    eventname: "",
    eventid: 0,
    marketId: "",
    selectionId: 0,
    runnername: "",
    betPrice: 0,
    type: "odds",
    betAmount: 0,
    profit: 0,
    side: "",
    status: 0,
  });

  function formatDate(isoString) {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  }

  const handleGames = async () => {
    try {
      const token = localStorage.getItem('game_token');
      const response = await axios.get(base_url + '/api/webapi/particularGame', {
        params: { token, provider: 'SPB' },
        withCredentials: true,
        headers: { 'content-type': 'application/json' },
      });
      const games = response?.data?.items;
      const avia = games?.filter(game => game?.name.includes('Aviator'));
      const id = avia[0]?.id;
      setAviator(id);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    handleGames();
  }, []);

  const openGameById = async (gameId) => {
    console.log('id', gameId);
    try {
      const token = localStorage.getItem('game_token');
      const response = await axios.post(base_url + '/api/gamelaunch/url',
        { token, gameId },
        {
          withCredentials: true,
          headers: { 'content-type': 'application/json' },
        }
      );
      if (response?.data.success) {
        const url = response?.data.url;
        window.location.href = url;
      } else {
        toast.error('Please Login to Play.');
        setactive(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleClick = (item) => {
    sessionStorage.clear();
    sessionStorage.setItem("marketId", item.marketId);
    sessionStorage.setItem("competetionid", item.competition.id);
    sessionStorage.setItem("eventid", item.event.id);
    sessionStorage.setItem("time", item?.event.openDate);
    sessionStorage.setItem("competitionname", item?.competition.name);
    sessionStorage.setItem("eventname", item?.event.name);

    if (item.eventType.name === "Cricket") {
      navigate("/cricketBet");
      sessionStorage.setItem("selectionid1", item?.runners[0].selectionId);
      sessionStorage.setItem("selectionid2", item?.runners[1].selectionId);
      sessionStorage.setItem("runner1", item.runners[0].runnerName);
      sessionStorage.setItem("runner2", item.runners[1].runnerName);
      if (item?.runners.length === 3) {
        sessionStorage.setItem("selectionid3", item?.runners[2].selectionId);
        sessionStorage.setItem("runner3", item.runners[2].runnerName);
      }
    } else if (item.eventType.name === "Soccer") {
      navigate("/footBAllBet");
      sessionStorage.setItem("selectionid1", item?.runners[0].selectionId);
      sessionStorage.setItem("selectionid2", item?.runners[1].selectionId);
      sessionStorage.setItem("selectionid3", item?.runners[2].selectionId);
      sessionStorage.setItem("runner1", item.runners[0].runnerName);
      sessionStorage.setItem("runner2", item.runners[1].runnerName);
      sessionStorage.setItem("runner3", item.runners[2].runnerName);
    } else if (item.eventType.name === "Tennis") {
      navigate("/tennis");
      sessionStorage.setItem("selectionid1", item?.runners[0].selectionId);
      sessionStorage.setItem("selectionid2", item?.runners[1].selectionId);
      sessionStorage.setItem("runner1", item.runners[0].runnerName);
      sessionStorage.setItem("runner2", item.runners[1].runnerName);
      if (item?.runners.length === 3) {
        sessionStorage.setItem("selectionid3", item?.runners[2].selectionId);
        sessionStorage.setItem("runner3", item.runners[2].runnerName);
      }
    }
  };

  useEffect(() => {
    matchDatabaseData();
  }, []);

  // ✅ When tab changes: clear old data and fetch fresh
  useEffect(() => {
    const fetchData = async () => {
      if (!lockedMatchesLoaded) return;

      // ✅ Clear all old data on tab switch
      setCricket([]);
      setRawMatches([]);
      setMarketList([]);
      setAvail([]);

      if (data === 0) {
        await matchData();
      } else if (data === 1) {
        await footballData();
      } else if (data === 2) {
        await tennisData();
      }
    };
    fetchData();
  }, [data, lockedMatchesLoaded]);

  useEffect(() => {
    if (!isNaN(selectedPrice) && !isNaN(money)) {
      const proft =
        parseFloat(selectedPrice) * parseFloat(money) - parseFloat(money);
      setProfit(proft.toFixed(1));
    }
  }, [selectedPrice, money]);

  // console.log("vall", avail);

  formData.competiton = competition;
  formData.eventid = eventid;
  formData.eventname = eventname;
  formData.marketId = selectedMatch;
  formData.selectionId = selectionid;
  formData.runnername = runner;
  formData.betPrice = selectedPrice;
  formData.betAmount = money;
  formData.side = side;
  formData.profit = profit;
  return (
    <>
      <div _ngcontent-jrx-c94="" className="wrap-conatiner mt-0">
        <div _ngcontent-jrx-c94="">
          <div
            _ngcontent-jrx-c94=""
            className="section tabs_boxes_section no-pad-bot no-pad-top"
          >
            <div _ngcontent-jrx-c94="" className="">
              <div className="live_matches mb-0 pb-0 gap-1 d-xl-flex d-flex w-100">
                {cricket
                  .filter((item) => new Date() >= new Date(item?.event?.openDate))
                  .map((item, index) => {

                    const teams = item?.event?.name?.split(" v ");

                    // console.log("teams", teams);

                    return (
                      <div
                        key={item?.event?.id || index}
                        className="col text-nowrap px-0"
                      >
                        <div className="latest-event-item mb-0">
                          <a className="blink_me" href="#">
                            <FaBaseballBatBall className="fs-5" />

                            <span className="px-2">
                              {teams?.[0]} vs {teams?.[1]}
                            </span>

                            <GiTennisBall className="fs-5" />
                          </a>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <ul
                class="nav nav-tabsSm py-2 d-xl-none menu-tabs"
                style={{ maxHeight: "45px" }}
              >
                <li class="nav-item">
                  <a class="nav-link px-0 py-1" onClick={() => openGameById(aviator)} data-discover="true">
                    <svg
                      style={{ transform: "rotate(4deg)" }}
                      id="Layer_2"
                      height="20px"
                      width="40px"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 457.6 277.4"
                      className="blink_me"
                    >
                      <defs>
                        <style>{`.cls-1 { fill: #e40539; }`}</style>
                      </defs>
                      <g id="Layer_1-2" data-name="Layer 1">
                        <g>
                          <path
                            className="cls-1"
                            d="M61.85,273.4c-1.8-3.5-2.3-3.9-4-3-3.2,1.7-5.5,1.1-9-2.5l-3.3-3.4,4.4-1.9c2.4-1.1,8-2.2,12.4-2.6,27.1-2.5,84.1-19.2,161-47.1,32.1-11.7,80.4-30.1,81.3-31,1.2-1.2-1-1.5-11.9-1.7-10.6-.2-11.7,0-16.5,2.4-13.1,6.8-74.6,31.2-92.8,36.7l-6.9,2.1-6.4-5-6.5-4.9-3.6,1.5c-21.3,9-88,36.4-89.2,36.6-1,.2-1.6-.6-1.8-2.3-.3-2.4.5-3,7.8-6.9,4.5-2.3,7.9-4.5,7.5-4.8-.3-.4-4.3-.9-8.9-1.3-9.7-.8-17.3-4-28.2-11.9-4.8-3.5-7.8-5-10-5-4.3,0-6.4.9-6.4,2.7,0,.8,6.8,8.7,15.1,17.6,13,13.7,14.9,16.2,13.3,16.8-3.7,1.5-4.8.8-16.3-10.3-6.4-6.2-14.6-14.2-18.3-17.7l-6.7-6.5-8.8,4.2-8.8,4.2-.3-3.4c-.2-2,.2-4.4.8-5.5s6.5-4.8,13.1-8.2c11.8-6,14.2-8,12.2-10-.7-.7-4.1.5-10.2,3.5l-9.1,4.6v-2.5c0-2,1.4-3.3,7.7-7,10.3-6,17.3-8.1,22.3-6.6,2.1.6,10.7,6.3,19.1,12.6,19,14.3,29.4,19.9,35.9,19.2,5.3-.5,34-13.7,61.9-28.5,18.3-9.7,21.6-12.1,19.5-14.2-.7-.7-7.1,1.8-21.4,8.5-14.7,7-20.5,9.3-21.1,8.4-1.2-2-.1-3.3,5.6-6.3,3-1.6,5.5-3.4,5.5-4,0-.7-1.3-2.5-2.8-4l-2.9-2.7-19.8,9.6c-10.9,5.2-20,9.3-20.2,9.1-.8-.7,2.5-12.8,3.8-14.1.8-.8,9.5-5.6,19.4-10.8,17.7-9.4,18-9.6,17.8-12.7,0-1.7-.4-3.4-.7-3.7s-3.9.9-8,2.7l-7.4,3.3-8.9-9.3c-4.8-5.1-8.9-9.6-9.1-10-.5-1.4,8.8-7.9,14.6-10.1,10.4-4,10.9-3.9,118.5,11.3,35.6,5,65.5,9.7,66.5,10.4,1.6,1.1,1.6,1.4-.1,4.8l-1.7,3.7,2.8,1c1.5.5,5.8,2.1,9.5,3.6l6.9,2.5,10.1-4.3c12.4-5.2,32.9-15.6,45.6-23.2l9.4-5.5,3.2,2.4c3.2,2.4,6.9,3.1,7.9,1.6.3-.5-2.5-6.9-6.3-14.3-3.7-7.4-8.7-18.4-11-24.4-2.4-6.1-4.8-11.6-5.4-12.4-.9-1-3.3-1.2-10.7-.8-10.8.5-18.1,2.6-42,12-15.4,6-67.7,31.5-70.6,34.4-1.3,1.4-3.4,1.4-19.2-.1-9.7-.9-18-1.6-18.4-1.6-1.4,0-.8-5.5,1.1-9.7,1.6-3.4,3.9-5.4,14-12.1,14.3-9.5,28.2-16.5,37.4-18.9l6.5-1.7,9.9,3.9c14.3,5.6,16.3,5.6,39.8-1,38.2-10.6,43.5-11.8,52.2-11.9,8-.1,8.3,0,11.6,3.3,2.6,2.5,5.7,8.3,12,23,4.7,10.8,9,21.3,9.7,23.5,1.7,5.4.8,11.9-2.4,16-6.7,8.8-38,25.2-82.1,42.8-22.8,9.1-61.8,21.9-162.5,53.3-31.1,9.7-64.7,20.3-74.6,23.6-10,3.2-18.9,5.9-19.8,5.9-.8,0-2.5-1.8-3.6-4ZM291.35,168.4c3.8-2.3,7.1-6.9,5.8-8-.6-.5-144.9-20.8-158.8-22.3-1.2-.1-2,.4-2,1.3,0,1.2,15.5,4.6,72,16.1,39.6,8.1,73.7,14.7,75.9,14.8,2.3.1,5.2-.7,7.1-1.9h0ZM247.65,122c4.2-2.3,11.2-5.8,15.4-7.7,4.3-1.9,7.8-3.7,7.8-4.1s-2.8-1.3-6.2-2c-7.7-1.7-13.7-.9-22.4,3.3-6.7,3.1-18.9,11.7-18.1,12.6.6.5,9.3,1.9,13.5,2.2,1.3,0,5.8-1.9,10-4.3h0ZM282.15,115.8c7.5-3.8,10.7-6,10.5-7.1-.4-2.1-18.3-9.2-23.4-9.3-2.2,0-4.9.6-6,1.4q-2.1,1.6,10.4,6.5c2.6,1,4.8,2.3,5,2.9s-1.9,2.2-4.7,3.6c-5.5,2.8-6.6,4-5.7,6.1.8,2.3,2.3,1.9,13.9-4.1h0Z"
                          ></path>
                          <path
                            className="cls-1"
                            d="M440.55,196.2c-6.8-10.1-13.5-20.3-14.9-22.8-1.5-2.5-5.5-14.1-9.1-25.7l-6.5-21.3,5.1-5c2.7-2.8,5.1-4.9,5.2-4.8.1.2,5.2,9.4,11.4,20.6,11.9,21.3,15.8,31,23.1,58,3.3,11.9,3.3,12.3,1.7,15.7-.9,1.9-2.1,3.5-2.6,3.5s-6.5-8.2-13.4-18.2h0ZM454.65,206.5c.2-1.9-.5-4.6-1.7-6.7-1.8-3.1-22-30.4-24.3-32.9-1.2-1.3-3,1.5-2.2,3.5,1.2,3.4,26,39.9,26.9,39.6.6-.1,1.1-1.7,1.3-3.5h0Z"
                          ></path>
                          <path
                            className="cls-1"
                            d="M295.35,148.3c-13.2-2.6-24.6-4.9-25.4-5.1-.8-.2,11.3-5.4,27-11.6l28.3-11.4,5.3,5.9c2.9,3.2,5.2,6.3,5.3,6.9,0,.6-2.3,5.5-5.1,10.8-4.8,9.1-5.2,9.6-8.2,9.5-1.8-.1-14-2.3-27.2-5h0Z"
                          ></path>
                          <path
                            className="cls-1"
                            d="M334.85,152.1c0-.2,1.6-3.6,3.6-7.5,1.9-4,4.1-9,4.9-11.1l1.3-3.8-5.3-6.9c-5.3-6.8-5.4-6.9-3.2-8.1,2-1.1,2.6-.8,6.2,3.2,2.2,2.5,4.3,4.5,4.6,4.5s1.7-3.9,3-8.7l2.4-8.8.3,4.9c.2,2.6-.2,8-.8,11.8l-1,7,5.1,6.4,5.1,6.4-2.7,1c-2.2.9-2.9.6-5-1.8-1.3-1.5-2.5-3-2.5-3.4-.1-2.3-1.9-.1-3.9,4.6-1.2,3-2.8,5.9-3.5,6.5-1.4,1.1-8.6,4.3-8.6,3.8h0Z"
                          ></path>
                          <path
                            className="cls-1"
                            d="M404.75,114.7c-7.2-16.1-7.3-16.4-5.8-17.5,1.5-1,21.2-.4,24.2.7.9.4,1.7,1.4,1.7,2.2,0,4.2-12.6,21.3-15.6,21.3-.9,0-2.8-2.9-4.5-6.7h0ZM414.15,104.7c4.8-2,8.7-4,8.7-4.4,0-1.2-4.4-1.9-13.2-1.9-8.2,0-8.8.1-8.8,2,0,2.4,2.7,8,3.8,8,.4,0,4.6-1.6,9.5-3.7Z"
                          ></path>
                          <path
                            className="cls-1"
                            d="M385.05,75.9c-10.7-19.1-14-27.3-20.7-51.6-4-14.3-4.3-18.7-1.6-22l1.9-2.3,14.8,22.3,14.8,22.3,7.6,24.2c4.2,13.2,7.4,24.2,7.1,24.3-.3.1-3.5.3-7.1.6l-6.5.4-10.3-18.2h0ZM391.85,46.5c0-1.5-23.2-37.5-26.1-40.6-1.3-1.3-2.9,1.2-2.9,4.7,0,2.5,8.8,15.4,22.3,32.7,4.6,6,6.7,7,6.7,3.2Z"
                          ></path>
                        </g>
                      </g>
                    </svg>
                    <span className="ml-2 pr-1">CRASH</span>
                  </a>
                </li>
                <li class="nav-item">

                </li>
                <li class="nav-item">
                  <a
                    aria-current="page"
                    class="nav-link active"
                    href="/home"
                    data-discover="true"
                  >
                    Sports
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link "
                    onClick={() => navigate("/casinoGames")}
                    data-discover="true"
                  >
                    Our Casino
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    className="nav-link"
                    onClick={() => navigate("/casinoGames", { state: { list: 7 } })}
                  >
                    Live Casino
                  </a>

                </li>
                <li class="nav-item">
                  <a
                    class="nav-link "
                    onClick={() => navigate("/casinoGames", { state: { list: 16 } })}
                    data-discover="true"
                  >
                    Slots
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    onClick={() => navigate("/casinoGames", { state: { list: 15 } })}
                    data-discover="true"
                  >
                    Black jack
                  </a>
                </li>

              </ul>

              <div
                _ngcontent-jrx-c94=""
                className="scrollable-listSm d-flex d-xl-none px-1"
              >
                {scrollableList.map((item, index) => {
                  const isDisabled = disabledItems.includes(item.name);
                  return (
                    <div
                      key={index}
                      _ngcontent-jrx-c94=""
                      className={`inp list-itemSm d-flex ${isActive === index ? "active" : ""
                        } first-item ng-star-inserted`}
                      onClick={() =>
                        isDisabled
                          ? handleClicktoast()
                          : handleActiveLink(index)
                      }
                    >
                      {" "}
                      <img
                        src={item.imgLink}
                        style={{ height: "16px", width: "16px" }}
                      />{" "}
                      {item.name}{" "}
                    </div>
                  );
                })}
              </div>
              <div
                _ngcontent-jrx-c94=""
                className="scrollable-list d-none d-xl-flex px-1"
                style={{ marginTop: "-12px" }}
              >
                {scrollableList.map((item, index) => {
                  const isDisabled = disabledItems.includes(item.name);
                  return (
                    <div
                      key={index}
                      _ngcontent-jrx-c94=""
                      className={`inp list-item ${isActive === index ? "active" : ""
                        } first-item ng-star-inserted`}
                      onClick={() =>
                        isDisabled
                          ? handleClicktoast()
                          : handleActiveLink(index)
                      }
                    >
                      {item.name}
                    </div>
                  );
                })}
              </div>
              <div _ngcontent-jrx-c94="" className="sports-wrapper">
                <div className="d-lg-block d-md-block d-none">
                  {cricket.length > 0 ? (
                    <>
                      <div className="row px-1 py-2 bet-table-header1">
                        <div className="col-lg-8 col-md-8 col-8 mb-0">
                          <h6
                            className="my-0 fw-bold"
                            style={{ color: themeColors["--text-body"] }}
                          >
                            Game
                          </h6>
                        </div>
                        <div className="col-lg-4 col-md-4 col-4 mb-0">
                          <div className="row mb-0">
                            <div className="col-lg-4 col-md-4 col-4 mb-0">
                              <h6
                                className="my-0 fw-bold"
                                style={{ color: themeColors["--text-body"] }}
                              >
                                1
                              </h6>
                            </div>
                            <div className="col-lg-4 col-md-4 col-4 mb-0">
                              <h6
                                className="my-0 fw-bold"
                                style={{ color: themeColors["--text-body"] }}
                              >
                                X
                              </h6>
                            </div>
                            <div className="col-lg-4 col-md-4 col-4 mb-0">
                              <h6
                                className="my-0 fw-bold"
                                style={{ color: themeColors["--text-body"] }}
                              >
                                2
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      {cricket
                        .filter((item) => {
                          const market = avail.find(m => m.marketId === item.marketId);

                          return (
                            market &&
                            market.runners?.some(
                              runner =>
                                runner?.ex?.availableToBack?.length > 0 ||
                                runner?.ex?.availableToLay?.length > 0
                            )
                          );
                        }).map((item, index) => {
                          const market = avail.find(m => m.marketId === item.marketId);

                          const runner1 = market?.runners?.[0];
                          const runner2 = market?.runners?.[1];

                          const r1Back = runner1?.ex?.availableToBack?.[0]?.price;
                          const r1Lay = runner1?.ex?.availableToLay?.[0]?.price;

                          const r2Back = runner2?.ex?.availableToBack?.[0]?.price;
                          const r2Lay = runner2?.ex?.availableToLay?.[0]?.price;


                          const marketData = market?.runners || [];
                          return (
                            <>
                              <div
                                key={index}
                                _ngcontent-jrx-c94=""
                                id={item?.competitionId}
                                className="flex-md-row justify-content-between ng-star-inserted"
                                style={{ position: "relative" }}
                              >
                                <div>
                                  {/* <p>{item.marketId}</p> */}
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="ng-star-inserted"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="section_details_box upcoming-data"
                                    >
                                      {item.isStarted && (
                                        <span
                                          _ngcontent-jrx-c94=""
                                          className="innerHTMLScore upcoming-score ng-star-inserted"
                                        >
                                          <div className="cricket-info">
                                            <div className="score">
                                              <span>
                                                item2
                                                <span className="vOver">
                                                  (45.0)
                                                </span>
                                              </span>
                                              <span className="vRun">
                                                0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                              </span>
                                              <span>
                                                item
                                                <span className="vOver">
                                                  (0.0)
                                                </span>
                                              </span>
                                            </div>
                                          </div>
                                        </span>
                                      )}

                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="sport-type-detail"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="runnners-odds-details"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="sport-name-wrapper"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_box_team py-0 my-0"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_box_t_name d-flex t_left fs-4"
                                                onClick={() =>
                                                  handleClick(item)
                                                }
                                              >
                                                
                                                {
                                                  item.runners[0]
                                                    ?.runnerName
                                                }{" "}
                                                <span
                                                  _ngcontent-jrx-c94=""
                                                  className="vs ng-star-inserted"
                                                >
                                                  {" "}
                                                  vs{" "}
                                                </span>
                                                {
                                                  item.runners[1]
                                                    ?.runnerName
                                                }
                                                <span className="fszz ms-1 mx-2">
                                                  {(() => {
                                                    const date = new Date(
                                                      item?.event?.openDate
                                                    );
                                                    const dd = String(
                                                      date.getDate()
                                                    ).padStart(2, "0");
                                                    const mm = String(
                                                      date.getMonth() + 1
                                                    ).padStart(2, "0");
                                                    const yyyy =
                                                      date.getFullYear();

                                                    let hours =
                                                      date.getHours();
                                                    const minutes = String(
                                                      date.getMinutes()
                                                    ).padStart(2, "0");
                                                    const seconds = String(
                                                      date.getSeconds()
                                                    ).padStart(2, "0");

                                                    const ampm =
                                                      hours >= 12
                                                        ? "PM"
                                                        : "AM";
                                                    hours = hours % 12;
                                                    hours = hours
                                                      ? hours
                                                      : 12;
                                                    const hh = String(
                                                      hours
                                                    ).padStart(2, "0");

                                                    return (
                                                      <>
                                                        <span
                                                        >
                                                          / {dd}/{mm}/{yyyy}
                                                        </span>
                                                        <span
                                                        >
                                                          {hh}:{minutes}:
                                                          {seconds} {ampm}
                                                        </span>
                                                      </>
                                                    );
                                                  })()}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="d-flex p-0">
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="middle-detail d-lg-flex d-md-flex d-none"
                                            >
                                              {new Date() >=
                                                  new Date(item?.event?.openDate) ? (
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="green-circle inplay-blinker ng-star-inserted mx-3"
                                                  ></div>
                                                ) : null}
                                              <img
                                                _ngcontent-jrx-c94=""
                                                className={`${new Date() >=
                                                    new Date(item?.event?.openDate)
                                                    ? "small-grid ng-star-inserted"
                                                    : "d-none"
                                                  }`}
                                                style={{
                                                  height: "18px",
                                                  width: "18px",
                                                }}
                                                src="/assets/paneal_images/tv (1).png"
                                                alt="TVKheloyaar360"
                                              />

                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="small-grid"
                                              >
                                                <span _ngcontent-jrx-c94="">
                                                  <img
                                                    className="imgfluid mx-2"
                                                    src="assets/paneal_images/fancy-icon1.png"
                                                  />
                                                </span>
                                                <span _ngcontent-jrx-c94="">
                                                  <img
                                                    className="imgfluid mx-2"
                                                    src="/assets/paneal_images/bm-icon1.png"
                                                  />
                                                </span>
                                                <span _ngcontent-jrx-c94="">
                                                  <img
                                                    className="imgfluid mx-2"
                                                    src="/assets/paneal_images/patte.webp"
                                                  />
                                                </span>
                                              </div>
                                            </div>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_odds_boxes_inn details_small_box_wrapper pt-0"
                                              style={{ position: "relative" }}
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_small_boxes"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_small_boxes_let"
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_small_boxes_inn ng-star-inserted"
                                                  >
                                                    {marketData &&
                                                      marketData.length > 0 && (
                                                        <div className="d-flex runnners-odds-details">
                                                          {(() => {
                                                            let backDivs = marketData.map((runner) => ({
                                                              price: runner?.ex?.availableToBack?.[0]?.price || null,
                                                              type: "Back",
                                                            }));

                                                            let layDivs = marketData.map((runner) => ({
                                                              price: runner?.ex?.availableToLay?.[0]?.price || null,
                                                              type: "Lay",
                                                            }));

                                                            while (
                                                              backDivs.length <
                                                              2
                                                            )
                                                              backDivs.push({
                                                                price: null,
                                                                type: "Back",
                                                              });
                                                            while (
                                                              layDivs.length < 2
                                                            )
                                                              layDivs.push({
                                                                price: null,
                                                                type: "Lay",
                                                              });

                                                            let combinedDivs = [
                                                              backDivs[0],
                                                              layDivs[0],
                                                              {
                                                                price: null,
                                                                type: "Back",
                                                              },
                                                              {
                                                                price: null,
                                                                type: "Lay",
                                                              },
                                                              backDivs[1],
                                                              layDivs[1],
                                                            ];

                                                            return combinedDivs.map(
                                                              (item, index) => (
                                                                <app-oddsbutton
                                                                  key={index}
                                                                >
                                                                  <div
                                                                    id={index}
                                                                    className={`d-md-flex d-none d-sm-none details_small_blue_box odds-box`}
                                                                    style={{
                                                                      backgroundColor:
                                                                        item.type ===
                                                                          "Lay"
                                                                          ? themeColors[
                                                                          "--dark-theme-data-box2"
                                                                          ]
                                                                          : themeColors[
                                                                          "--dark-theme-data-box"
                                                                          ],
                                                                    }}
                                                                  // onClick={() => handleBetClick(item, index, marketid)}
                                                                  >
                                                                    <span className="ng-star-inserted">
                                                                      {item.price !==
                                                                        null
                                                                        ? item.price
                                                                        : "--"}
                                                                    </span>
                                                                  </div>
                                                                </app-oddsbutton>
                                                              )
                                                            );
                                                          })()}
                                                        </div>
                                                      )}
                                                  </div>
                                                </div>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  style={{ clear: "both" }}
                                                ></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* betting back div */}


                                {/* betting lay div */}

                              </div>
                            </>
                          );
                        })}
                    </>
                  ) : (
                    <div
                      style={{
                        backgroundColor: themeColors["--bg-table"],
                        borderBottom: "1px solid var(--table-border)",
                        fontSize: "15px",
                        color: themeColors["--text-body"],
                      }}
                    >
                      No Record Found
                    </div>
                  )}
                </div>

                <div className="d-lg-none d-md-none d-block">
                  {cricket.length > 0 ? (
                    cricket
                      .filter((item) => {
                        const market = avail.find(m => m.marketId === item.marketId);

                        return (
                          market &&
                          market.runners?.some(
                            runner =>
                              runner?.ex?.availableToBack?.length > 0 ||
                              runner?.ex?.availableToLay?.length > 0
                          )
                        );
                      }).map((item, index) => {
                        const market = avail.find(m => m.marketId === item.marketId);

                        const runner1 = market?.runners?.[0];
                        const runner2 = market?.runners?.[1];

                        const r1Back = runner1?.ex?.availableToBack?.[0]?.price;
                        const r1Lay = runner1?.ex?.availableToLay?.[0]?.price;

                        const r2Back = runner2?.ex?.availableToBack?.[0]?.price;
                        const r2Lay = runner2?.ex?.availableToLay?.[0]?.price;
                        const marketData = market?.runners || [];

                        return (
                          <>
                            <div
                              key={index}
                              _ngcontent-jrx-c94=""
                              id={item?.competition?.id}
                              className="flex-md-row justify-content-between ng-star-inserted"
                              style={{ position: "relative" }}
                            >
                              <div>
                                {/* <p>{item.marketId}</p> */}
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="ng-star-inserted"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="section_details_box upcoming-data"
                                  >
                                    {item.isStarted && (
                                      <span
                                        _ngcontent-jrx-c94=""
                                        className="innerHTMLScore upcoming-score ng-star-inserted"
                                      >
                                        <div className="cricket-info">
                                          <div className="score">
                                            <span>
                                              item2
                                              <span className="vOver">
                                                (45.0)
                                              </span>
                                            </span>
                                            <span className="vRun">
                                              0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                            </span>
                                            <span>
                                              item
                                              <span className="vOver">
                                                (0.0)
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </span>
                                    )}

                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="sport-type-detail"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="runnners-odds-details pe-1 d-flex flex-column"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="sport-name-wrapper"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_box_team py-0 my-0 justify-content-between"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_box_t_name t_left fs-4"
                                              onClick={() => handleClick(item)}
                                            >
                                              {" "}
                                              <span>
                                                {
                                                  item.runners[0]
                                                    .runnerName
                                                }{" "}
                                              </span>
                                              <span
                                                _ngcontent-jrx-c94=""
                                                className="vs ng-star-inserted"
                                              >
                                                {" "}
                                                vs{" "}
                                              </span>
                                              <span>
                                                {
                                                  item.runners[1]
                                                    .runnerName
                                                }
                                              </span>
                                              <div className="data_date">
                                                <span className="fszz">
                                                  {(() => {
                                                    const date = new Date(
                                                      item?.event?.openDate
                                                    );
                                                    const dd = String(
                                                      date.getDate()
                                                    ).padStart(2, "0");
                                                    const mm = String(
                                                      date.getMonth() + 1
                                                    ).padStart(2, "0");
                                                    const yyyy =
                                                      date.getFullYear();

                                                    let hours = date.getHours();
                                                    const minutes = String(
                                                      date.getMinutes()
                                                    ).padStart(2, "0");
                                                    const seconds = String(
                                                      date.getSeconds()
                                                    ).padStart(2, "0");

                                                    const ampm =
                                                      hours >= 12 ? "PM" : "AM";
                                                    hours = hours % 12;
                                                    hours = hours ? hours : 12;
                                                    const hh = String(
                                                      hours
                                                    ).padStart(2, "0");

                                                    return `${dd}/${mm}/${yyyy} ${hh}:${minutes}:${seconds} ${ampm}`;
                                                  })()}
                                                </span>{" "}
                                                <span
                                                  _ngcontent-jrx-c94=""
                                                  className={`${new Date() >=
                                                      new Date(item?.event?.openDate)
                                                      ? "green-circle inplay-blinker ng-star-inserted mx-1"
                                                      : ""
                                                    }`}
                                                ></span>
                                              </div>
                                            </div>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="middle-detail d-lg-none d-md-none d-block"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="small-grid"
                                              >
                                                <span
                                                  _ngcontent-jrx-c94=""
                                                  className={`${new Date() >=
                                                      new Date(item?.event?.openDate)
                                                      ? "green-circle inplay-blinker ng-star-inserted"
                                                      : ""
                                                    }`}
                                                ></span>
                                                <span _ngcontent-jrx-c94="">
                                                  <img
                                                    className="imgfluid ms-1"
                                                    src="assets/paneal_images/fancy-icon1.png"
                                                  />
                                                </span>
                                                <span _ngcontent-jrx-c94="">
                                                  <img
                                                    className="imgfluid"
                                                    src="/assets/paneal_images/bm-icon1.png"
                                                  />
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row py-1 bet-table-header2">
                                          <div className="col-md-4 col-4 mb-0">
                                            <h6
                                              className="my-0 fw-bold fs-7 text-center"
                                              style={{
                                                color:
                                                  themeColors["--text-body"],
                                              }}
                                            >
                                              1
                                            </h6>
                                          </div>
                                          <div className="col-md-4 col-4 mb-0">
                                            <h6
                                              className="my-0 fw-bold fs-7 text-center"
                                              style={{
                                                color:
                                                  themeColors["--text-body"],
                                              }}
                                            >
                                              X
                                            </h6>
                                          </div>
                                          <div className="col-md-4 col-4 mb-0">
                                            <h6
                                              className="my-0 fw-bold fs-7 text-center"
                                              style={{
                                                color:
                                                  themeColors["--text-body"],
                                              }}
                                            >
                                              2
                                            </h6>
                                          </div>
                                        </div>
                                        <div className="row p-0 me-0">
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_small_boxes pe-0"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_small_boxes_let"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_small_boxes_inn ng-star-inserted w-100 d-block"
                                              >
                                                {marketData &&
                                                  marketData.length > 0 && (
                                                    <div className="d-flex runnners-odds-details">
                                                      {(() => {
                                                        let backDivs = marketData.map((runner) => ({
                                                          price: runner?.ex?.availableToBack?.[0]?.price || null,
                                                          type: "Back",
                                                        }));

                                                        let layDivs = marketData.map((runner) => ({
                                                          price: runner?.ex?.availableToLay?.[0]?.price || null,
                                                          type: "Lay",
                                                        }));

                                                        while (
                                                          backDivs.length <
                                                          2
                                                        )
                                                          backDivs.push({
                                                            price: null,
                                                            type: "Back",
                                                          });
                                                        while (
                                                          layDivs.length < 2
                                                        )
                                                          layDivs.push({
                                                            price: null,
                                                            type: "Lay",
                                                          });

                                                        let combinedDivs = [
                                                          backDivs[0],
                                                          layDivs[0],
                                                          {
                                                            price: null,
                                                            type: "Back",
                                                          },
                                                          {
                                                            price: null,
                                                            type: "Lay",
                                                          },
                                                          backDivs[1],
                                                          layDivs[1],
                                                        ];

                                                        return combinedDivs.map(
                                                          (item, index) => (
                                                            <app-oddsbutton
                                                              key={index}
                                                            >
                                                              <div
                                                                id={index}
                                                                className={`d-md-flex d-none d-sm-none details_small_blue_box odds-box`}
                                                                style={{
                                                                  backgroundColor:
                                                                    item.type ===
                                                                      "Lay"
                                                                      ? themeColors[
                                                                      "--dark-theme-data-box2"
                                                                      ]
                                                                      : themeColors[
                                                                      "--dark-theme-data-box"
                                                                      ],
                                                                }}
                                                              // onClick={() => handleBetClick(item, index, marketid)}
                                                              >
                                                                <span className="ng-star-inserted">
                                                                  {item.price !==
                                                                    null
                                                                    ? item.price
                                                                    : "--"}
                                                                </span>
                                                              </div>
                                                            </app-oddsbutton>
                                                          )
                                                        );
                                                      })()}
                                                    </div>
                                                  )}
                                              </div>
                                            </div>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              style={{ clear: "both" }}
                                            ></div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>



                            </div>
                          </>
                        );
                      })
                  ) : (
                    <div
                      style={{
                        backgroundColor: themeColors["--bg-table"],
                        borderBottom: "1px solid var(--table-border)",
                        fontSize: "15px",
                        color: themeColors["--text-body"],
                      }}
                    >
                      No Record Found
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Tomorrow = ({ data }) => {
  const navigate = useNavigate();
  const [cricket, setCricket] = useState([]);
  const [avail, setAvail] = useState();
  const { themeColors } = useTheme();
  const [lockedMatch, setLockedMatch] = useState([]);
  const [lockedMatchesLoaded, setLockedMatchesLoaded] = useState(false); // NEW

  const [loading, setLoading] = useState(true);

  const matchDatabaseData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        base_url + "/api/webapi/matchDatabaseData",
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      setLockedMatch(response.data.data);
      setLockedMatchesLoaded(true); // Set as loaded
    } catch (error) {
      console.error("API Error:", error);
    } finally {
    }
  };

  console.log("locked match", lockedMatch);

  let allData = [];

  const isTomorrow = (eventDate) => {
    const now = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(now.getDate() + 1); // Get tomorrow's date

    const tomorrowFormatted = formatDate(tomorrow);
    const eventFormatted = formatDate(eventDate);

    // console.log("Tomorrow's Date:", tomorrowFormatted);
    // console.log("Event Date:", eventFormatted);

    return tomorrowFormatted === eventFormatted; // Compare only dates
  };

  const matchData = async () => {
    console.log("match data is called before");
    try {
      const response = await axios.get(base_url + "/api/webapi/matchapi", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      // console.log("match data is called")
      // console.log("API Response:", response?.data.result);
      const data = response?.data.result;

      // Step 1: Get array of locked event IDs
      const lockedEventIds = lockedMatch.map((match) => match.eventid);

      data?.map((dta) => {
        const openDate = dta?.event.openDate;
        const eventId = dta?.event?.id;
        // console.log('openDate',openDate);

        const isLocked = lockedEventIds.includes(eventId);
        // console.log("is locked ", eventId,  isLocked);

        // console.log(dta);
        if (!isLocked && isTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const footballData = async () => {
    console.log("football data is called before");

    try {
      const response = await axios.get(base_url + "/api/webapi/footballapi", {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("football data is called");

      const data = response?.data.result;

      const lockedEventIds = lockedMatch.map((match) => match.eventid);
      const allData = [];

      data?.forEach((dta) => {
        const openDate = dta?.event?.openDate;
        const eventId = dta?.event?.id;

        const isLocked = lockedEventIds.includes(eventId);

        if (!isLocked && isTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const tennisData = async () => {
    console.log("tennis data is called before");

    try {
      const response = await axios.get(base_url + "/api/webapi/tennisapi", {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("tennis data is called");

      const data = response?.data.result;

      const lockedEventIds = lockedMatch.map((match) => match.eventid);
      const allData = [];

      data?.forEach((dta) => {
        const openDate = dta?.event?.openDate;
        const eventId = dta?.event?.id;

        const isLocked = lockedEventIds.includes(eventId);

        if (!isLocked && isTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  // Fetch cricket/football/tennis when `data` changes
  // 1. Fetch matchData only on mount or when `data` changes
  useEffect(() => {
    matchDatabaseData(); // Runs once on mount
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!lockedMatchesLoaded) return; // Wait until locked matches are loaded

      if (data === 0) {
        await matchData();
      } else if (data === 1) {
        await footballData();
      } else if (data === 2) {
        await tennisData();
      }
    };

    fetchData();
  }, [data, lockedMatchesLoaded]);

  useEffect(() => {
    const oddsData = async () => {
      if (cricket.length === 0) return;

      try {
        const marketid = cricket.map((item) => item.marketId);

        const response = await axios.post(
          `${base_url}/api/webapi/market/wholeMarket`,
          marketid,
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 10000,
          }
        );

        const result = JSON.parse(response.data);
        setAvail(result);
      } catch (err) {
        console.error("Error fetching odds data:", err);
      }
    };

    oddsData();
  }, [cricket]);

  return (
    <>
      <div _ngcontent-jrx-c94="" className="wrap-conatiner">
        <div _ngcontent-jrx-c94="">
          <div
            _ngcontent-jrx-c94=""
            className="section tabs_boxes_section no-pad-bot no-pad-top"
          >
            <div _ngcontent-jrx-c94="" className="">
              <div _ngcontent-jrx-c94="">
                {cricket?.length > 0 ? (
                  cricket
                    .filter(
                      (item) =>
                        avail &&
                        avail[item.marketId] &&
                        avail[item.marketId].length > 0 &&
                        avail[item.marketId].some(
                          (market) =>
                            market?.ex?.availableToBack?.length > 0 ||
                            market?.ex?.availableToLay?.length > 0
                        )
                    )
                    .map((item, index) => {
                      const market = avail.find((m) => m.marketId === item.marketId);
                      const marketData = market?.runners || [];
                      // console.log('arr',marketData);

                      return (
                        <div
                          key={index}
                          _ngcontent-jrx-c94=""
                          id={item?.competition?.id}
                          className="flex-md-row justify-content-between  rounded ng-star-inserted"
                          style={{ position: "relative" }}
                        >
                          <div>
                            <div>
                              <span className="text-yellow fszz">
                                {/*new Date(item?.event.openDate).toISOString().split("T")[0]*/}
                                Tomorrow
                              </span>{" "}
                              <span className="text-yellow fszz">
                                {new Date(
                                  item?.event.openDate
                                ).toLocaleTimeString([], {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: false,
                                })}
                              </span>
                            </div>
                            {/* <p>{item.marketId}</p> */}
                            <div
                              _ngcontent-jrx-c94=""
                              className="ng-star-inserted"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="section_details_box upcoming-data"
                              >
                                {item.isStarted && (
                                  <span
                                    _ngcontent-jrx-c94=""
                                    className="innerHTMLScore upcoming-score ng-star-inserted"
                                  >
                                    <div className="cricket-info">
                                      <div className="score">
                                        <span>
                                          {item.title1}
                                          <span className="vOver">(45.0)</span>
                                        </span>
                                        <span className="vRun">
                                          0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                        </span>
                                        <span>
                                          {item.title2}
                                          <span className="vOver">(0.0)</span>
                                        </span>
                                      </div>
                                    </div>
                                  </span>
                                )}

                                <div
                                  _ngcontent-jrx-c94=""
                                  className="sport-type-detail"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="runnners-odds-details"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="sport-name-wrapper"
                                    >
                                      <div
                                        style={{ color: "#186787" }}
                                        _ngcontent-jrx-c94=""
                                        className="details_box_team"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="details_box_t_name t_left fs-4"
                                          onClick={() =>
                                            navigate(
                                              "/cricketBet",
                                              sessionStorage.setItem(
                                                "marketId",
                                                item.marketId
                                              ),
                                              sessionStorage.setItem(
                                                "competetionid",
                                                item.competition.id
                                              ),
                                              sessionStorage.setItem(
                                                "eventid",
                                                item.event.id
                                              ),
                                              sessionStorage.setItem(
                                                "time",
                                                item?.event.openDate
                                              ),
                                              sessionStorage.setItem(
                                                "competitionname",
                                                item?.competition.name
                                              ),
                                              sessionStorage.setItem(
                                                "eventname",
                                                item?.event.name
                                              ),
                                              sessionStorage.setItem(
                                                "selectionid1",
                                                item?.runners[0].selectionId
                                              ),
                                              sessionStorage.setItem(
                                                "selectionid2",
                                                item?.runners[1].selectionId
                                              ),

                                              sessionStorage.setItem(
                                                "runner1",
                                                item.runners[0].runnerName
                                              ),
                                              sessionStorage.setItem(
                                                "runner2",
                                                item.runners[1].runnerName
                                              ),
                                              {
                                                state: {
                                                  marketId: item.marketId,
                                                  runner1:
                                                    item.runners[0].runnerName,
                                                  runner2:
                                                    item.runners[1].runnerName,
                                                },
                                              }
                                            )
                                          }
                                        >
                                          {" "}
                                          {item.runners[0].runnerName}{" "}
                                          <span
                                            _ngcontent-jrx-c94=""
                                            className="vs ng-star-inserted"
                                          >
                                            {" "}
                                            vs{" "}
                                          </span>
                                          {item.runners[1].runnerName}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="d-flex p-1 ">
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="middle-detail"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className={`${item.isStarted
                                              ? "green-circle inplay-blinker ng-star-inserted"
                                              : ""
                                            }`}
                                        ></div>
                                        <img
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >=
                                              new Date(item?.event.openDate)
                                              ? "small-grid ng-star-inserted"
                                              : "d-none"
                                            }`}
                                          style={{
                                            height: "18px",
                                            width: "18px",
                                          }}
                                          src="/assets/paneal_images/tv (1).png"
                                          alt="TVKheloyaar360"
                                        />

                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="small-grid"
                                        >
                                          <span _ngcontent-jrx-c94="">
                                            <img
                                              className="imgfluid ms-1"
                                              src="assets/paneal_images/fancy-icon1.png"
                                            />
                                          </span>
                                          <span _ngcontent-jrx-c94="">
                                            <img
                                              className="imgfluid"
                                              src="/assets/paneal_images/bm-icon1.png"
                                            />
                                          </span>
                                        </div>
                                        {/* <div
                                    _ngcontent-jrx-c94=""
                                    className="small-grid d-md-block d-none"
                                  >
                                    <span _ngcontent-jrx-c94=""> BF</span>
                                  </div> */}
                                      </div>
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_odds_boxes_inn details_small_box_wrapper p-1"
                                        style={{ position: "relative" }}
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="details_small_boxes"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_small_boxes_let"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_small_boxes_inn ng-star-inserted"
                                            >
                                              {marketData &&
                                                marketData.length > 0 && (
                                                  <div className="d-flex runnners-odds-details gap-1">
                                                    {(() => {
                                                      let backDivs =
                                                        marketData.flatMap(
                                                          (market) =>
                                                            market?.ex
                                                              ?.availableToBack
                                                              ?.length > 0
                                                              ? [
                                                                {
                                                                  price:
                                                                    market.ex
                                                                      .availableToBack[0]
                                                                      .price,
                                                                  type: "back",
                                                                },
                                                              ]
                                                              : []
                                                        );
                                                      let layDivs =
                                                        marketData.flatMap(
                                                          (market) =>
                                                            market?.ex
                                                              ?.availableToLay
                                                              ?.length > 0
                                                              ? [
                                                                {
                                                                  price:
                                                                    market.ex
                                                                      .availableToLay[0]
                                                                      .price,
                                                                  type: "lay",
                                                                },
                                                              ]
                                                              : []
                                                        );

                                                      // Fill up with empty divs if needed to ensure 6 elements
                                                      while (
                                                        backDivs.length < 2
                                                      )
                                                        backDivs.push({
                                                          price: null,
                                                          type: "back",
                                                        });
                                                      while (layDivs.length < 2)
                                                        layDivs.push({
                                                          price: null,
                                                          type: "lay",
                                                        });

                                                      let combinedDivs = [
                                                        backDivs[0],
                                                        layDivs[0],
                                                        {
                                                          price: null,
                                                          type: "back",
                                                        }, // Empty Back
                                                        {
                                                          price: null,
                                                          type: "lay",
                                                        }, // Empty Lay
                                                        backDivs[1],
                                                        layDivs[1],
                                                      ];

                                                      return combinedDivs.map(
                                                        (item, index) => (
                                                          <app-oddsbutton
                                                            key={index}
                                                          >
                                                            <div
                                                              id={index}
                                                              className={`d-md-flex ${item.type ===
                                                                  "lay"
                                                                  ? "bg-pink"
                                                                  : ""
                                                                } d-none d-sm-none details_small_blue_box odds-box p-0`}
                                                            >
                                                              <span className="ng-star-inserted">
                                                                {item.price !==
                                                                  null
                                                                  ? item.price
                                                                  : "--"}
                                                              </span>
                                                            </div>
                                                          </app-oddsbutton>
                                                        )
                                                      );
                                                    })()}
                                                  </div>
                                                )}

                                              {/* <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            >
                                              1.05
                                            </span>
                                          </div> */}

                                              {/* <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            >
                                              1.06
                                            </span>
                                          </div>
                                        </app-oddsbutton>{" "}

                                        <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_blue_box lesser_odds_opacity odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            ></span>
                                          </div>
                                          <div className="box_without_size d-flex d-md-none d-sm-flex details_small_blue_box lesser_odds_opacity small_box_col ng-star-inserted">
                                            <span appratehighlight=""> </span>
                                          </div>
                                        </app-oddsbutton>
                                        <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_pink_box lesser_odds_opacity odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            ></span>
                                          </div>
                                          <div className="box_without_size d-flex d-md-none d-sm-flex details_small_pink_box lesser_odds_opacity small_box_col ng-star-inserted">
                                            <span appratehighlight=""> </span>
                                          </div>
                                        </app-oddsbutton>{" "}

                                        <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            >
                                              19.5
                                            </span>
                                          </div>
                                        </app-oddsbutton>
                                        <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            >
                                              20
                                            </span>
                                          </div>
                                        </app-oddsbutton> */}
                                            </div>
                                          </div>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            style={{ clear: "both" }}
                                          ></div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                ) : (
                  <div
                    style={{
                      backgroundColor: themeColors["--bg-table"],
                      borderBottom: "1px solid var(--table-border)",
                      fontSize: "15px",
                      color: themeColors["--text-body"],
                    }}
                  >
                    No Record Found
                  </div>
                )}

                {/* virtualCricket */}
                {/* {data === 0 && (
                  <div>
                    <div
                      _ngcontent-jrx-c94=""
                      className="virtual-sport status-box ng-star-inserted"
                    >
                      <span
                        _ngcontent-jrx-c94=""
                        className="new-disp-flex market-name"
                      >
                        <img
                          _ngcontent-jrx-c94=""
                          src="/assets/images/virtual-cricket.svg"
                          alt="Virtual CricketKheloyaar360"
                        />{" "}
                        Virtual Cricket
                      </span>
                      <span
                        _ngcontent-jrx-c94=""
                        routerlink="/sports/competitionsmarkets/70707070"
                        className="see-more"
                        tabIndex="0"
                      >
                        {" "}
                        View More
                      </span>
                    </div>
                    <div _ngcontent-jrx-c94="" className="ng-star-inserted">
                      <div
                        _ngcontent-jrx-c94=""
                        className="section_details_box upcoming-data"
                      >
                        <div
                          _ngcontent-jrx-c94=""
                          className="inplay-btn upcoming-score ng-star-inserted"
                        >
                          {" "}
                          In Play
                        </div>
                        <div
                          _ngcontent-jrx-c94=""
                          className="sport-type-detail"
                        >
                          <div
                            _ngcontent-jrx-c94=""
                            className="runnners-odds-details"
                          >
                            <div
                              _ngcontent-jrx-c94=""
                              className="sport-name-wrapper"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="details_box_team"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_box_t_name t_left"
                                  onClick={()=>navigate('/cricketBet')}
                                >
                                  {" "}
                                  Dolphins{" "}
                                  <span _ngcontent-jrx-c94="" className="vs">
                                    {" "}
                                    vs{" "}
                                  </span>
                                  Western Province{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-jrx-c94=""
                              className="middle-detail"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="green-circle inplay-blinker ng-star-inserted"
                              ></div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> LMT</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> XTRA</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> FM</span>
                              </div>
                              <div _ngcontent-jrx-c94="" className="small-grid">
                                <span _ngcontent-jrx-c94=""> BM</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> BF</span>
                              </div>
                            </div>
                            <div
                              _ngcontent-jrx-c94=""
                              className="details_odds_boxes_inn details_small_box_wrapper"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="details_small_boxes"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_small_boxes_let"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_small_boxes_inn ng-star-inserted"
                                  >
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>{" "}
                                    &nbsp; &nbsp; &nbsp;{" "}
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box lesser_odds_opacity odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                      <div className="box_without_size d-flex d-md-none d-sm-flex details_small_blue_box lesser_odds_opacity small_box_col ng-star-inserted">
                                        <span appratehighlight=""> </span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box lesser_odds_opacity odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                      <div className="box_without_size d-flex d-md-none d-sm-flex details_small_pink_box lesser_odds_opacity small_box_col ng-star-inserted">
                                        <span appratehighlight=""> </span>
                                      </div>
                                    </app-oddsbutton>{" "}
                                    &nbsp; &nbsp; &nbsp;{" "}
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  style={{ clear: "both" }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div _ngcontent-jrx-c94="" className="ng-star-inserted">
                      <div
                        _ngcontent-jrx-c94=""
                        className="section_details_box upcoming-data"
                      >
                        <div
                          _ngcontent-jrx-c94=""
                          className="inplay-btn upcoming-score ng-star-inserted"
                        >
                          {" "}
                          In Play
                        </div>
                        <div
                          _ngcontent-jrx-c94=""
                          className="sport-type-detail"
                        >
                          <div
                            _ngcontent-jrx-c94=""
                            className="runnners-odds-details"
                          >
                            <div
                              _ngcontent-jrx-c94=""
                              className="sport-name-wrapper"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="details_box_team"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_box_t_name t_left"
                                  onClick={()=>navigate('/cricketBet')}
                                >
                                  {" "}
                                  Warriors{" "}
                                  <span _ngcontent-jrx-c94="" className="vs">
                                    {" "}
                                    vs{" "}
                                  </span>
                                  North west{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-jrx-c94=""
                              className="middle-detail"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="green-circle inplay-blinker ng-star-inserted"
                              ></div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> LMT</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> XTRA</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> FM</span>
                              </div>
                              <div _ngcontent-jrx-c94="" className="small-grid">
                                <span _ngcontent-jrx-c94=""> BM</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> BF</span>
                              </div>
                            </div>
                            <div
                              _ngcontent-jrx-c94=""
                              className="details_odds_boxes_inn details_small_box_wrapper"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="details_small_boxes"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_small_boxes_let"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_small_boxes_inn ng-star-inserted"
                                  >
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>{" "}
                                    &nbsp; &nbsp; &nbsp;{" "}
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box lesser_odds_opacity odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                      <div className="box_without_size d-flex d-md-none d-sm-flex details_small_blue_box lesser_odds_opacity small_box_col ng-star-inserted">
                                        <span appratehighlight=""> </span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box lesser_odds_opacity odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                      <div className="box_without_size d-flex d-md-none d-sm-flex details_small_pink_box lesser_odds_opacity small_box_col ng-star-inserted">
                                        <span appratehighlight=""> </span>
                                      </div>
                                    </app-oddsbutton>{" "}
                                    &nbsp; &nbsp; &nbsp;{" "}
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  style={{ clear: "both" }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Upcoming = ({ data }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [cricket, setCricket] = useState([]);
  const [avail, setAvail] = useState([]);
  const [lockedMatch, setLockedMatch] = useState([]);
  const [lockedMatchesLoaded, setLockedMatchesLoaded] = useState(false); // NEW
  const { themeColors } = useTheme();

  const matchDatabaseData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        base_url + "/api/webapi/matchDatabaseData",
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      setLockedMatch(response.data.data);
      setLockedMatchesLoaded(true); // Set as loaded
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };
  console.log("locked match", lockedMatch);
  let allData = [];

  const isAfterTomorrow = (eventDate) => {
    const now = new Date();
    const afterTomorrow = new Date();
    afterTomorrow.setDate(now.getDate() + 2); // Get the day after tomorrow

    const eventFormatted = formatDate(eventDate);
    const afterTomorrowFormatted = formatDate(afterTomorrow);
    // console.log('afterr',afterTomorrowFormatted);

    return eventFormatted >= afterTomorrowFormatted; // Checks if event is after tomorrow
  };

  const matchData = async () => {
    console.log("upcoming match data called before ");
    try {
      const response = await axios.get(base_url + "/api/webapi/matchapi", {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("match data is called before ");
      const data = response?.data.result;

      const lockedEventIds = lockedMatch.map((match) => match.eventid);
      const allData = [];

      data?.forEach((dta) => {
        const openDate = dta?.event?.openDate;
        const eventId = dta?.event?.id;

        const isLocked = lockedEventIds.includes(eventId);

        if (!isLocked && isAfterTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const footballData = async () => {
    console.log("football upcoming called before ");
    try {
      const response = await axios.get(base_url + "/api/webapi/footballapi", {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("football after upcoming");
      const data = response?.data.result;

      const lockedEventIds = lockedMatch.map((match) => match.eventid);
      const allData = [];

      data?.forEach((dta) => {
        const openDate = dta?.event?.openDate;
        const eventId = dta?.event?.id;

        const isLocked = lockedEventIds.includes(eventId);

        if (!isLocked && isAfterTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const tennisData = async () => {
    try {
      const response = await axios.get(base_url + "/api/webapi/tennisapi", {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("tennis after upcoming");
      const data = response?.data.result;

      const lockedEventIds = lockedMatch.map((match) => match.eventid);
      const allData = [];

      data?.forEach((dta) => {
        const openDate = dta?.event?.openDate;
        const eventId = dta?.event?.id;

        const isLocked = lockedEventIds.includes(eventId);

        if (!isLocked && isAfterTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    matchDatabaseData(); // Runs once on mount
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!lockedMatchesLoaded) return; // Wait until locked matches are loaded

      if (data === 0) {
        await matchData();
      } else if (data === 1) {
        await footballData();
      } else if (data === 2) {
        await tennisData();
      }
    };

    fetchData();
  }, [data, lockedMatchesLoaded]);

  // 2. When cricket is updated, then call odds API
  useEffect(() => {
    const oddsData = async () => {
      if (cricket.length === 0) return;

      try {
        const marketid = cricket.map((item) => item.marketId);

        const response = await axios.post(
          `${base_url}/api/webapi/market/wholeMarket`,
          marketid,
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 10000,
          }
        );

        const result = JSON.parse(response.data); // Remove JSON.parse if response is already JSON
        setAvail(result);
      } catch (err) {
        console.error("Error fetching odds data:", err);
      }
    };

    oddsData();
  }, [cricket]); // This effect ONLY runs when `cricket` changes

  // console.log(cricket);

  return (
    <>
      <div _ngcontent-jrx-c94="" className="wrap-conatiner">
        <div _ngcontent-jrx-c94="">
          <div
            _ngcontent-jrx-c94=""
            className="section tabs_boxes_section no-pad-bot no-pad-top"
          >
            <div _ngcontent-jrx-c94="" className="">
              <div _ngcontent-jrx-c94="" className="sports-wrapper">
                {cricket?.length > 0 ? (
                  cricket
                    .filter(
                      (item) =>
                        avail &&
                        avail[item.marketId] &&
                        avail[item.marketId].length > 0 &&
                        avail[item.marketId].some(
                          (market) =>
                            market?.ex?.availableToBack?.length > 0 ||
                            market?.ex?.availableToLay?.length > 0
                        )
                    )
                    .map((item, index) => {
                      const market = avail.find((m) => m.marketId === item.marketId);
                      const marketData = market?.runners || [];
                      // console.log('arr',marketData);

                      return (
                        <>
                          <div
                            key={index}
                            _ngcontent-jrx-c94=""
                            id={item?.competition?.id}
                            className="flex-md-row justify-content-between  rounded ng-star-inserted"
                            style={{ position: "relative" }}
                          >
                            <span className="text-yellow fszz">
                              {new Date(
                                item?.event.openDate
                              ).toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: false,
                              })}
                            </span>{" "}
                            <span className="text-yellow fszz">
                              {
                                new Date(item?.event.openDate)
                                  .toISOString()
                                  .split("T")[0]
                              }
                            </span>
                            {/* <p>{item.marketId}</p> */}
                            <div
                              _ngcontent-jrx-c94=""
                              className="ng-star-inserted"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="section_details_box upcoming-data"
                              >
                                {item.isStarted && (
                                  <span
                                    _ngcontent-jrx-c94=""
                                    className="innerHTMLScore upcoming-score ng-star-inserted"
                                  >
                                    <div className="cricket-info">
                                      <div className="score">
                                        <span>
                                          {item.title1}
                                          <span className="vOver">(45.0)</span>
                                        </span>
                                        <span className="vRun">
                                          0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                        </span>
                                        <span>
                                          {item.title2}
                                          <span className="vOver">(0.0)</span>
                                        </span>
                                      </div>
                                    </div>
                                  </span>
                                )}

                                <div
                                  _ngcontent-jrx-c94=""
                                  className="sport-type-detail"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="runnners-odds-details"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="sport-name-wrapper"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_box_team"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="details_box_t_name t_left fs-4"
                                          onClick={() =>
                                            navigate(
                                              "/cricketBet",
                                              sessionStorage.setItem(
                                                "marketId",
                                                item.marketId
                                              ),
                                              sessionStorage.setItem(
                                                "competetionid",
                                                item.competition.id
                                              ),
                                              sessionStorage.setItem(
                                                "eventid",
                                                item.event.id
                                              ),
                                              sessionStorage.setItem(
                                                "time",
                                                item?.event.openDate
                                              ),
                                              sessionStorage.setItem(
                                                "competitionname",
                                                item?.competition.name
                                              ),
                                              sessionStorage.setItem(
                                                "eventname",
                                                item?.event.name
                                              ),
                                              sessionStorage.setItem(
                                                "selectionid1",
                                                item?.runners[0].selectionId
                                              ),
                                              sessionStorage.setItem(
                                                "selectionid2",
                                                item?.runners[1].selectionId
                                              ),

                                              sessionStorage.setItem(
                                                "runner1",
                                                item.runners[0].runnerName
                                              ),
                                              sessionStorage.setItem(
                                                "runner2",
                                                item.runners[1].runnerName
                                              ),
                                              {
                                                state: {
                                                  marketId: item.marketId,
                                                  runner1:
                                                    item.runners[0].runnerName,
                                                  runner2:
                                                    item.runners[1].runnerName,
                                                },
                                              }
                                            )
                                          }
                                        >
                                          {" "}
                                          {item?.event?.name}{" "}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="d-flex p-1">
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="middle-detail"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className={`${item.isStarted
                                              ? "green-circle inplay-blinker ng-star-inserted"
                                              : ""
                                            }`}
                                        ></div>
                                        <img
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >=
                                              new Date(item?.event.openDate)
                                              ? "small-grid ng-star-inserted"
                                              : "d-none"
                                            }`}
                                          style={{
                                            height: "18px",
                                            width: "18px",
                                          }}
                                          src="/assets/paneal_images/tv (1).png"
                                          alt="TVKheloyaar360"
                                        />

                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="small-grid"
                                        >
                                          <span _ngcontent-jrx-c94="">
                                            <img
                                              className="imgfluid ms-1"
                                              src="assets/paneal_images/fancy-icon1.png"
                                            />
                                          </span>
                                          <span _ngcontent-jrx-c94="">
                                            <img
                                              className="imgfluid"
                                              src="/assets/paneal_images/bm-icon1.png"
                                            />
                                          </span>
                                        </div>
                                        {/* <div
                                    _ngcontent-jrx-c94=""
                                    className="small-grid d-md-block d-none"
                                  >
                                    <span _ngcontent-jrx-c94=""> BF</span>
                                  </div> */}
                                      </div>
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_odds_boxes_inn details_small_box_wrapper p-1"
                                        style={{ position: "relative" }}
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="details_small_boxes"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_small_boxes_let"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_small_boxes_inn ng-star-inserted"
                                            >
                                              {marketData &&
                                                marketData.length > 0 && (
                                                  <div className="d-flex runnners-odds-details gap-1">
                                                    {(() => {
                                                      let backDivs =
                                                        marketData.flatMap(
                                                          (market) =>
                                                            market?.ex
                                                              ?.availableToBack
                                                              ?.length > 0
                                                              ? [
                                                                {
                                                                  price:
                                                                    market.ex
                                                                      .availableToBack[0]
                                                                      .price,
                                                                  type: "back",
                                                                },
                                                              ]
                                                              : []
                                                        );
                                                      let layDivs =
                                                        marketData.flatMap(
                                                          (market) =>
                                                            market?.ex
                                                              ?.availableToLay
                                                              ?.length > 0
                                                              ? [
                                                                {
                                                                  price:
                                                                    market.ex
                                                                      .availableToLay[0]
                                                                      .price,
                                                                  type: "lay",
                                                                },
                                                              ]
                                                              : []
                                                        );

                                                      // Fill up with empty divs if needed to ensure 6 elements
                                                      while (
                                                        backDivs.length < 2
                                                      )
                                                        backDivs.push({
                                                          price: null,
                                                          type: "back",
                                                        });
                                                      while (layDivs.length < 2)
                                                        layDivs.push({
                                                          price: null,
                                                          type: "lay",
                                                        });

                                                      let combinedDivs = [
                                                        backDivs[0],
                                                        layDivs[0],
                                                        {
                                                          price: null,
                                                          type: "back",
                                                        }, // Empty Back
                                                        {
                                                          price: null,
                                                          type: "lay",
                                                        }, // Empty Lay
                                                        backDivs[1],
                                                        layDivs[1],
                                                      ];

                                                      return combinedDivs.map(
                                                        (item, index) => (
                                                          <app-oddsbutton
                                                            key={index}
                                                          >
                                                            <div
                                                              id={index}
                                                              className={`d-md-flex ${item.type ===
                                                                  "lay"
                                                                  ? "bg-pink"
                                                                  : ""
                                                                } d-none d-sm-none details_small_blue_box odds-box p-0`}
                                                            >
                                                              <span className="ng-star-inserted">
                                                                {item.price !==
                                                                  null
                                                                  ? item.price
                                                                  : "--"}
                                                              </span>
                                                            </div>
                                                          </app-oddsbutton>
                                                        )
                                                      );
                                                    })()}
                                                  </div>
                                                )}

                                              {/* <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            >
                                              1.05
                                            </span>
                                          </div> */}

                                              {/* <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            >
                                              1.06
                                            </span>
                                          </div>
                                        </app-oddsbutton>{" "}

                                        <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_blue_box lesser_odds_opacity odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            ></span>
                                          </div>
                                          <div className="box_without_size d-flex d-md-none d-sm-flex details_small_blue_box lesser_odds_opacity small_box_col ng-star-inserted">
                                            <span appratehighlight=""> </span>
                                          </div>
                                        </app-oddsbutton>
                                        <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_pink_box lesser_odds_opacity odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            ></span>
                                          </div>
                                          <div className="box_without_size d-flex d-md-none d-sm-flex details_small_pink_box lesser_odds_opacity small_box_col ng-star-inserted">
                                            <span appratehighlight=""> </span>
                                          </div>
                                        </app-oddsbutton>{" "}

                                        <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            >
                                              19.5
                                            </span>
                                          </div>
                                        </app-oddsbutton>
                                        <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            >
                                              20
                                            </span>
                                          </div>
                                        </app-oddsbutton> */}
                                            </div>
                                          </div>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            style={{ clear: "both" }}
                                          ></div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })
                ) : (
                  <div
                    style={{
                      backgroundColor: themeColors["--bg-table"],
                      borderBottom: "1px solid var(--table-border)",
                      fontSize: "15px",
                      color: themeColors["--text-body"],
                    }}
                  >
                    No Record Found
                  </div>
                )}

                {/* virtualCricket */}
                {/* {data === 0 && (
                  <div>
                    <div
                      _ngcontent-jrx-c94=""
                      className="virtual-sport status-box ng-star-inserted"
                    >
                      <span
                        _ngcontent-jrx-c94=""
                        className="new-disp-flex market-name"
                      >
                        <img
                          _ngcontent-jrx-c94=""
                          src="/assets/images/virtual-cricket.svg"
                          alt="Virtual CricketKheloyaar360"
                        />{" "}
                        Virtual Cricket
                      </span>
                      <span
                        _ngcontent-jrx-c94=""
                        routerlink="/sports/competitionsmarkets/70707070"
                        className="see-more"
                        tabIndex="0"
                      >
                        {" "}
                        View More
                      </span>
                    </div>
                    <div _ngcontent-jrx-c94="" className="ng-star-inserted">
                      <div
                        _ngcontent-jrx-c94=""
                        className="section_details_box upcoming-data"
                      >
                        <div
                          _ngcontent-jrx-c94=""
                          className="inplay-btn upcoming-score ng-star-inserted"
                        >
                          {" "}
                          In Play
                        </div>
                        <div
                          _ngcontent-jrx-c94=""
                          className="sport-type-detail"
                        >
                          <div
                            _ngcontent-jrx-c94=""
                            className="runnners-odds-details"
                          >
                            <div
                              _ngcontent-jrx-c94=""
                              className="sport-name-wrapper"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="details_box_team"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_box_t_name t_left"
                                  onClick={()=>navigate('/cricketBet')}
                                >
                                  {" "}
                                  Dolphins{" "}
                                  <span _ngcontent-jrx-c94="" className="vs">
                                    {" "}
                                    vs{" "}
                                  </span>
                                  Western Province{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-jrx-c94=""
                              className="middle-detail"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="green-circle inplay-blinker ng-star-inserted"
                              ></div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> LMT</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> XTRA</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> FM</span>
                              </div>
                              <div _ngcontent-jrx-c94="" className="small-grid">
                                <span _ngcontent-jrx-c94=""> BM</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> BF</span>
                              </div>
                            </div>
                            <div
                              _ngcontent-jrx-c94=""
                              className="details_odds_boxes_inn details_small_box_wrapper"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="details_small_boxes"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_small_boxes_let"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_small_boxes_inn ng-star-inserted"
                                  >
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>{" "}
                                    &nbsp; &nbsp; &nbsp;{" "}
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box lesser_odds_opacity odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                      <div className="box_without_size d-flex d-md-none d-sm-flex details_small_blue_box lesser_odds_opacity small_box_col ng-star-inserted">
                                        <span appratehighlight=""> </span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box lesser_odds_opacity odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                      <div className="box_without_size d-flex d-md-none d-sm-flex details_small_pink_box lesser_odds_opacity small_box_col ng-star-inserted">
                                        <span appratehighlight=""> </span>
                                      </div>
                                    </app-oddsbutton>{" "}
                                    &nbsp; &nbsp; &nbsp;{" "}
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  style={{ clear: "both" }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div _ngcontent-jrx-c94="" className="ng-star-inserted">
                      <div
                        _ngcontent-jrx-c94=""
                        className="section_details_box upcoming-data"
                      >
                        <div
                          _ngcontent-jrx-c94=""
                          className="inplay-btn upcoming-score ng-star-inserted"
                        >
                          {" "}
                          In Play
                        </div>
                        <div
                          _ngcontent-jrx-c94=""
                          className="sport-type-detail"
                        >
                          <div
                            _ngcontent-jrx-c94=""
                            className="runnners-odds-details"
                          >
                            <div
                              _ngcontent-jrx-c94=""
                              className="sport-name-wrapper"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="details_box_team"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_box_t_name t_left"
                                  onClick={()=>navigate('/cricketBet')}
                                >
                                  {" "}
                                  Warriors{" "}
                                  <span _ngcontent-jrx-c94="" className="vs">
                                    {" "}
                                    vs{" "}
                                  </span>
                                  North west{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-jrx-c94=""
                              className="middle-detail"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="green-circle inplay-blinker ng-star-inserted"
                              ></div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> LMT</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> XTRA</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> FM</span>
                              </div>
                              <div _ngcontent-jrx-c94="" className="small-grid">
                                <span _ngcontent-jrx-c94=""> BM</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> BF</span>
                              </div>
                            </div>
                            <div
                              _ngcontent-jrx-c94=""
                              className="details_odds_boxes_inn details_small_box_wrapper"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="details_small_boxes"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_small_boxes_let"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_small_boxes_inn ng-star-inserted"
                                  >
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>{" "}
                                    &nbsp; &nbsp; &nbsp;{" "}
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box lesser_odds_opacity odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                      <div className="box_without_size d-flex d-md-none d-sm-flex details_small_blue_box lesser_odds_opacity small_box_col ng-star-inserted">
                                        <span appratehighlight=""> </span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box lesser_odds_opacity odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                      <div className="box_without_size d-flex d-md-none d-sm-flex details_small_pink_box lesser_odds_opacity small_box_col ng-star-inserted">
                                        <span appratehighlight=""> </span>
                                      </div>
                                    </app-oddsbutton>{" "}
                                    &nbsp; &nbsp; &nbsp;{" "}
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  style={{ clear: "both" }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const Home = () => {
  const [isSidebar, setSidebar] = useState(false);
  const [isInplay, setInplay] = useState(true);
  const [isTomorrow, setTomorrow] = useState(false);
  const [isUpcoming, setUpcoming] = useState(false);
  const [isActive, setActiveLink] = useState(0);
  const [jiliGames, setJiliGames] = useState([]);
  const [token, setToken] = useState();
  const [casino, setCasino] = useState([]);
  const [ent, setEnt] = useState([]);
  const [endorphina, setEndorphina] = useState([]);
  // const [latest, setLatest]= useState([]);
  const [evolution, setEvolution] = useState([]);
  const [games, setGames] = useState([]);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const { themeColors } = useTheme();
  const navigate = useNavigate();
  const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);
  const [toastActive, setToastActive] = useState(false);
  const { setEventSource } = useContext(AuthContext);

  const handleClicktoast = () => {
    toast.success("Coming soon");
  };

  useEffect(() => {
    const hasSeenModal = localStorage.getItem("hasSeenLoginModal");
    if (!hasSeenModal) {
      setShowLoginModal(true);
    }
  }, []);

  const handleCloseModal = () => {
    localStorage.setItem("hasSeenLoginModal", "true");
    setShowLoginModal(false);
  };

  const handlePlay = (id) => {
    setInplay(false);
    setTomorrow(false);
    setUpcoming(false);

    if (id === "inplay") {
      setInplay(true);
    } else if (id === "tomorrow") {
      setTomorrow(true);
    } else {
      setUpcoming(true);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };
    let eventSource;
    const casinogames = async () => {
      try {
        if (eventSource.current) {
  eventSource.current.close(); // 👈 BEFORE creating new
}
        eventSource = new EventSource(base_url + "/api/valid/token", {
          withCredentials: true,
        });
        setEventSource(eventSource);
        let receivedGames = [];

        // Provider groupings
        const allowedProviders = [
          "Playtech Live",
          "Playtech Casino",
          "Skywind Casino",
          "RTG Slots",
          "7Mojos Casino",
          "ICONIC21",
          "Habanero",
        ];
        const voltProvide = [
          "Red Tiger Gaming",
          "Betgames",
          "Netgame",
          "OnlyPlay",
          "CQ9 Casino",
          "Live88",
        ];
        const endorphina = ["Qora", "Ezugi", "Gamizx", "Triple PG", "Evoplay"];
        const latst = ["ICONIC21", "Live88", "Spribe", "Aviatrix"];
        const evoluton = ["Evolution Gaming"];

        const classifyAndSetBuckets = (gamesList) => {
          const jili = [],
            casino = [],
            ent = [],
            endor = [],
            latest = [],
            evolution = [];

          gamesList.forEach((game) => {
            const providerName = game?.provider?.name;
            if (!providerName) return;

            if (providerName === "Jili") jili.push(game);
            if (allowedProviders.includes(providerName)) casino.push(game);
            if (voltProvide.includes(providerName)) ent.push(game);
            if (endorphina.includes(providerName)) endor.push(game);
            if (latst.includes(providerName)) latest.push(game);
            if (evoluton.includes(providerName)) evolution.push(game);
          });

          // Update UI buckets
          setJiliGames(jili);
          setCasino(casino);
          setEnt(ent);
          setEndorphina(endor);
          // setLatest(latest);
          setEvolution(evolution);
        };

        eventSource.addEventListener("message", (event) => {
          const data = JSON.parse(event.data);

          // Save token
          if (data.token) {
            setToken(data.token);
            localStorage.setItem("game_token", data.token);
          }

          // New chunk arrives
          if (data.chunk && Array.isArray(data.chunk)) {
            receivedGames = [...receivedGames, ...data.chunk];

            setGames([...receivedGames]);
            classifyAndSetBuckets(receivedGames);
          }

          // All chunks done
          if (data.complete) {
            eventSource.close();
          }

          if (data.error) {
            eventSource.close();
          }
        });

        eventSource.onerror = (error) => {
          eventSource.close();
        };
      } catch (err) {
        console.error("Error initializing game stream:", err);
      }
    };

    casinogames();
    handleResize();
    return () => {
    if (eventSource) {
      eventSource.close();
    }
  };
  }, []);

  const handleActiveLink = (index) => {
    setActiveLink(index);
  };

  const scrollableList = [
    { name: "Cricket", imgLink: "/assets/images/cricket.svg" },
    { name: "Football", imgLink: "/assets/images/football.webp" },
    { name: "Tennis", imgLink: "/assets/images/Tennis New.svg" },
    { name: "Politics", imgLink: "/assets/images/baseball-svgrepo-com 1.svg" },
    { name: "Kabaddi", imgLink: "/assets/images/baseball-svgrepo-com 1.svg" },
    { name: "Esoccer", imgLink: "/assets/images/Basketbaalls.svg" },
    {
      name: "Horse Racing",
      imgLink: "/assets/images/baseball-svgrepo-com 1.svg",
    },
    {
      name: "Greyhound Racing",
      imgLink: "/assets/images/baseball-svgrepo-com 1.svg",
    },
    {
      name: "Table Tennis",
      imgLink: "/assets/images/baseball-svgrepo-com 1.svg",
    },
    {
      name: "Basketball",
      imgLink: "/assets/images/baseball-svgrepo-com 1.svg",
    },
    { name: "Boxing", imgLink: "/assets/images/baseball-svgrepo-com 1.svg" },
  ];

  const disabledItems = [
    "Politics",
    "Kabaddi",
    "Esoccer",
    "Horse Racing",
    "Greyhound Racing",
    "Table Tennis",
    "Basketball",
    "Boxing",
  ];

  const isSmallScreen = window.innerWidth <= 768;
  const styles = {
    marqueeDiv: {
      background:
        "linear-gradient(rgb(103, 205, 246) 0%, rgb(51, 147, 186) 50%, rgb(0, 66, 92) 100%)",
      zIndex: 99,
      position: "fixed",
      bottom: 0,
      width: "100%",
    },
  };

  const [showCanvas, setShowCanvas] = useState(false);

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);

  //  const [isSidebar2, setSidebar2] = useState(false);
  // const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsMobile(window.innerWidth <= 768);
  //   };

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 991);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      {isAuthenticated && (
        <LoginModal show={showLoginModal} handleClose={handleCloseModal} />
      )}
      <div _ngcontent-jrx-c101="">
        <app-toasts
          _ngcontent-jrx-c101=""
          aria-live="polite"
          aria-atomic="true"
          className="ngb-toasts"
        ></app-toasts>
        <router-outlet _ngcontent-jrx-c101=""></router-outlet>
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            {/* {!isMobile && <TopBar />}
            {isMobile && <Header isSidebar2={isSidebar2} setSidebar={setSidebar} />} */}
            {/* {isLargeScreen && <TopBar />} */}
            <Header
              isSidebar={isSidebar}
              setSidebar={setSidebar}
              show={showCanvas}
              handleShow={handleCanvasShow}
              handleClose={handleCanvasClose}
            />
            <div _ngcontent-jrx-c95="" className="body-container mb-1">
              <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  paddingLeft: isLargeScreen ? "0px" : "0px",
                  paddingRight: isLargeScreen ? "3px" : "0px",
                  width: isSidebar ? "" : "100%",
                  // transition: "width 0.3s ease-in-out",
                }}
              >
                <div
                  _ngcontent-jrx-c95=""
                  className="sports-casino mt-15 d-none"
                >
                  <ul _ngcontent-jrx-c95="" className="popular-tab">
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/sportsbyid/4"
                      style={{
                        background:
                          "linear-gradient(270deg, #c435ef 0%, #662ef3 100%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Cricket
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/cricket.svg"
                        alt="Cricket_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/sportsbyid/1"
                      style={{
                        background:
                          "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Football
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/football.webp"
                        alt="Football_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/sportsbyid/2"
                      style={{
                        background:
                          "linear-gradient(91deg, #f7a545 0.66%, #d8560c 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Tennis
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/tennis.webp"
                        alt="Tennis_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/sportsbyid/7522"
                      style={{
                        background:
                          "linear-gradient(91deg, #ec62e2 0.66%, #9c31f0 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Basketball
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/basketball.webp"
                        alt="Basketball_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/raceschedule/7/ALL"
                      style={{
                        background: themeColors["--dark-theme-time-remaining"],
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Horse Racing
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/horse-racing.gif"
                        style={{ height: "35px" }}
                        alt="Horse-racing_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/raceschedule/4339/ALL"
                      style={{
                        background:
                          "linear-gradient(270deg, #c435ef 0%, #662ef3 100%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Greyhound
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/Greyhound transparent.gif"
                        style={{ height: "35px" }}
                        alt="Greyhound_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/sportsbyid/6"
                      style={{
                        background:
                          "linear-gradient(91deg, #f7a545 0.66%, #d8560c 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Boxing
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/horse-racing.gif"
                        style={{ height: "35px" }}
                        alt="Boxing_Kheloyaar360"
                      />
                    </li>
                  </ul>
                </div>
                <div _ngcontent-jrx-c95="" className="sports-casino d-none">
                  <ul _ngcontent-jrx-c95="" className="popular-tab">
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/casinos/games/LIVECASINO"
                      style={{
                        background:
                          "linear-gradient(91deg, #ec62e2 0.66%, #9c31f0 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Live Casino
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/live_casino.webp"
                        alt="Live Casino_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/casinos/games/ROULETTE"
                      style={{
                        background:
                          "linear-gradient(90deg, #20a635 2.29%, #22ff7a 83.94%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Casino Lobby
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/casino_lobby.webp"
                        alt="Casino Lobby_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      style={{
                        background:
                          "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
                      }}
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Crazy Time
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/crazy_time.webp"
                        alt="Crazy Time_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/casinos/games/INSTANTWIN"
                      style={{
                        background:
                          "linear-gradient(270deg, #3984f7 0%, #242156 100%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Crash Games
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/crash_games.webp"
                        alt="Crash Games_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      style={{
                        background:
                          "linear-gradient(91deg, #ec62e2 0.66%, #9c31f0 99.47%)",
                      }}
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Virtual Sports
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/virtual_sports.webp"
                        alt="Virtual Sports_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      style={{
                        background:
                          "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
                      }}
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Evolution
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/evolution.webp"
                        alt="Evolution_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/casinos/games/TABLEGAME"
                      style={{
                        background:
                          "linear-gradient(91deg, #ec62e2 0.66%, #9c31f0 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Table Games
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/table_games.webp"
                        alt="Table Games_Kheloyaar360"
                      />
                    </li>
                  </ul>
                </div>

                {/* <CategoryGrid></CategoryGrid> */}

                <app-upcoming
                  _ngcontent-jrx-c95=""
                  _nghost-jrx-c94=""
                  className="ng-star-inserted"
                >
                  <div
                    _ngcontent-jrx-c94=""
                    className="upcoming-container"
                  ></div>
                  {/* <div class="latest-event mb-0 mb-xl-2 gap-1 d-xl-flex"><div class="latest-event-item mb-0"><a class="blink_me py-1" href="#" data-discover="true"><i class="d-icon me-1 icon-4"></i><span>England U19 v India U19</span></a></div><div class="latest-event-item mb-0"><a class="blink_me" href="#" data-discover="true"><i class="d-icon me-1 icon-4"></i><span>Amo Sharks v Band-e Amir Dragons</span></a></div></div> */}

                  {/* <div _ngcontent-jrx-c94="" className="scrollable-listSm d-flex d-xl-none px-1">
                    {scrollableList.map((item, index) => {
                      const isDisabled = disabledItems.includes(item.name);
                      return (
                        <div
                          key={index}
                          _ngcontent-jrx-c94=""
                          className={`inp list-itemSm d-flex ${isActive === index ? "active" : ""
                            } first-item ng-star-inserted`}
                          onClick={() => isDisabled ? handleClicktoast() : handleActiveLink(index)}
                        >{" "}
                          <img src={item.imgLink} style={{ height: "16px", width: "16px" }} /> {item.name}{" "}
                        </div>
                      );
                    })}
                  </div>
                  <div _ngcontent-jrx-c94="" className="scrollable-list d-none d-xl-flex px-1">
                    {scrollableList.map((item, index) => {
                      const isDisabled = disabledItems.includes(item.name);
                      return (
                        <div
                          key={index}
                          _ngcontent-jrx-c94=""
                          className={`inp list-item ${isActive === index ? "active" : ""} first-item ng-star-inserted`}
                          onClick={() => isDisabled ? handleClicktoast() : handleActiveLink(index)}
                        >
                          {item.name}
                        </div>
                      );
                    })}

                  </div> */}
                  <Inplay
                    data={isActive}
                    scrollableList={scrollableList}
                    isActive={isActive}
                    disabledItems={disabledItems}
                    handleClicktoast={handleClicktoast}
                    handleActiveLink={handleActiveLink}
                  />
                </app-upcoming>

                <div className="pb-3">
                  <Racing />
                </div>

                {/* <Footer /> */}
              </div>
            </div>
            <MarqueeBottom onMenuClick={handleCanvasShow} />
          </div>
        </app-landing-page-new>
        <div className="slider-container"></div>
      </div>
    </app-root>
  );
};